import axiosClient from "./axiosClient";
import AppCookie from '../helpers/AppCookie';

class VietQrModel {
  constructor() {
    this.api_url = "/api/bank-name-bill";
  }

  async getAllVietQR(credentials) {
    const res = await axiosClient.get(this.api_url, {
      params: {
        type: credentials.type,
      },
    });
    return res;
  }

  async getBankMB() {
    const res = await axiosClient.get(this.api_url + '/get-bank-mb');
    return res;
  }

  async getQRdeposit(credentials, type = 'MB') {
    const res = await axiosClient.get('/api/deposit/qr', {
      params: {
        addInfo: 'user ' + credentials.username + ' payment',
        type: type,
      },
    });
    return res;
  }

  async getQrTPB(credentials) {
    const res = await axiosClient.get('/api/deposit/getQrTPB', {
      params: {
        addInfo: 'user ' + credentials.username + ' payment',
      },
    });
    return res;
  }

  async getOwnerBank(type) {
    const res = await axiosClient.get('/api/owner_bank', {
      params: {
        type: type,
      },
    });
    return res;
  }
}

export default new VietQrModel;